import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import STRtree from '../../index/strtree/STRtree';
import IsValidOp from './IsValidOp';
import PointLocation from '../../algorithm/PointLocation';
import ArrayList from '../../../../../java/util/ArrayList';
import Envelope from '../../geom/Envelope';
var IndexedNestedRingTester = /*#__PURE__*/function () {
  function IndexedNestedRingTester() {
    _classCallCheck(this, IndexedNestedRingTester);
    IndexedNestedRingTester.constructor_.apply(this, arguments);
  }
  _createClass(IndexedNestedRingTester, [{
    key: "buildIndex",
    value: function buildIndex() {
      this._index = new STRtree();
      for (var i = 0; i < this._rings.size(); i++) {
        var ring = this._rings.get(i);
        var env = ring.getEnvelopeInternal();
        this._index.insert(env, ring);
      }
    }
  }, {
    key: "getNestedPoint",
    value: function getNestedPoint() {
      return this._nestedPt;
    }
  }, {
    key: "isNonNested",
    value: function isNonNested() {
      this.buildIndex();
      for (var i = 0; i < this._rings.size(); i++) {
        var innerRing = this._rings.get(i);
        var innerRingPts = innerRing.getCoordinates();
        var results = this._index.query(innerRing.getEnvelopeInternal());
        for (var j = 0; j < results.size(); j++) {
          var searchRing = results.get(j);
          var searchRingPts = searchRing.getCoordinates();
          if (innerRing === searchRing) continue;
          if (!innerRing.getEnvelopeInternal().intersects(searchRing.getEnvelopeInternal())) continue;
          var innerRingPt = IsValidOp.findPtNotNode(innerRingPts, searchRing, this._graph);
          if (innerRingPt === null) continue;
          var isInside = PointLocation.isInRing(innerRingPt, searchRingPts);
          if (isInside) {
            this._nestedPt = innerRingPt;
            return false;
          }
        }
      }
      return true;
    }
  }, {
    key: "add",
    value: function add(ring) {
      this._rings.add(ring);
      this._totalEnv.expandToInclude(ring.getEnvelopeInternal());
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._graph = null;
      this._rings = new ArrayList();
      this._totalEnv = new Envelope();
      this._index = null;
      this._nestedPt = null;
      var graph = arguments[0];
      this._graph = graph;
    }
  }]);
  return IndexedNestedRingTester;
}();
export { IndexedNestedRingTester as default };